import { Avatar, Flex, Text } from '@amigoapp/doca-react';

const DoctorCard = ({ title, name, avatar, councilName, councilNumber, specialty, ...props }) => {
	const councilText = councilName && councilNumber ? `${councilName} ${councilNumber}` : '';
	const specialtyText = specialty ? `  • ${specialty}` : '';

	return (
		<Flex align="center" gap={3} {...props}>
			<Avatar rounded withDefaultAvatar urls={[avatar]} />
			<Flex align="start" className="doca-text--left" direction="col" gap={1}>
				<Text variant="gray" weight="light">{title ? `${title} ${name}` : name}</Text>
				{(councilText || specialty) && <Text as="small" fontSize={12} size="extra-small" variant="gray" weight="light">{councilText}{specialtyText}</Text>}
			</Flex>
		</Flex>
	);
};

export default DoctorCard;
